enum HttpStatusCode {
  // 4xx
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,

  // 5xx
  INTERNAL_SERVER_ERROR = 500,
}

export default HttpStatusCode;
